// export const IMAGE_BASE_URL = "https://orbitaviation.in/public/images/"

export const DATE_FORMATS = {
	DATE_ONLY_FORMAT: 'DD/MM/YYYY',
	DATE_TIME_FORMAT: 'DD/MM/YYYY hh:mm:ss A',
	DATE_SERVER_FORMAT: 'YYYY-MM-DD'
}

export const STATUS_LIST = [
	{
		id: -1,
		key: 'select_status',
		title: 'Select Status'
	},
	{
		id: 1,
		key: 'enabled',
		title: 'Enabled'
	},
	{
		id: 0,
		key: 'disabled',
		title: 'Disabled'
	}
]
export const APPLICATION_STATUS_LIST = [
	{
		id: -1,
		key: 'select_status',
		title: 'Select Status'
	},
	{
		id: 'pending',
		key: 'pending',
		title: 'Pending Verification'
	},
	{
		id: 'eligible',
		key: 'eligible',
		title: 'Eligible'
	},
	{
		id: 'not_eligible',
		key: 'not_eligible',
		title: 'Eligible But Not Assisted'
	},
	{
		id: 'benefit_given',
		key: 'benefit_given',
		title: 'Benefit given'
	},
	{
		id: 'reject',
		key: 'reject',
		title: 'Not Eligible (Rejected)'
	}
]
export const ROLES_MAP = {
	'super_admin': 1,
	'administrator': 2,
	'director': 3,
	'department_officer': 4,
	'district_officer': 5,
	'field_officer': 6,
	'dpm': 7
}

export const ROLES_CONSTANTS = [
	{
		id: 1,
		slug: 'super_admin',
		title: 'Super admin'
	},
	{
		id: 2,
		slug: 'administrator',
		title: 'Admin'
	},
	{
		id: 3,
		slug: 'director',
		title: 'Director'
	},
	{
		id: 4,
		slug: 'department_officer',
		title: 'Department officer'
	},
	{
		id: 5,
		slug: 'district_officer',
		title: 'District officer'
	},
	{
		id: 6,
		slug: 'field_officer',
		title: 'Field officer'
	},
	{
		id: 7,
		slug: 'dpm',
		title: 'DPM'
	}
]

export const PAGE_LIMIT = 15

export const MESSAGES = {
	NO_RECORD_FOUND: 'NO RECORD FOUND'
}

export const REPORT_DATE_TYPES = [
	{
		id: 7,
		label: 'Last 15 days',
		month: 1,
		days: 15
	},
	{
		id: 1,
		label: 'Last 30 days',
		month: 1,
		days: 30
	},
	{
		id: 6,
		label: 'Last 45 days',
		month: 3,
		days: 45
	},
	{
		id: 2,
		label: 'Last 60 days',
		month: 2,
		days: 60
	},
	{
		id: 5,
		label: 'Last 75 days',
		month: 3,
		days: 75
	},
	{
		id: 3,
		label: 'Last 90 days',
		month: 3,
		days: 90
	},
	{
		id: 4,
		label: 'Custom',
	}
]

export const DASHBOARD_FILTERS = [
	{
		id: 0,
		slug: 'district_wise',
		label: 'District wise'
	},
	{
		id: 2,
		slug: 'department_wise',
		label: 'Department wise'
	},
	{
		id: 1,
		slug: 'scheme_wise',
		label: 'Scheme wise'
	}
]

export const APPLICATION_STATUS = {
	PENDING_VERIFICATION: 'Pending Verfication',
	ELIGBLE: 'Eligible',
	ELIGBLE_BUT_NOT_ASSITED: 'Eligible But Not Assisted',
	BENIFIT_GIVEN: 'Benefit Given',
	NOT_ELIGBLE_REJECTED: 'Not Eligible (Rejected)',
	TOTAL: 'Total applications',
	RE_APPLIED: 'Re applied'	
}

export const APPLICATION_KEYS = {
	PENDING_VERIFICATION: 'pending',
	ELIGBLE: 'eligible',
	ELIGBLE_BUT_NOT_ASSITED: 'not_eligible',
	BENIFIT_GIVEN: 'benefit_given',
	NOT_ELIGBLE_REJECTED: 'reject',
}

export const MONTHS = ['January', 'February', 'March', 'April', 'May', 'June', 'July', 'August', 'September', 'October', 'November', 'December']